import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import PropTypes from 'prop-types'

// Utils
import { linkIsActive } from '../MainMenu/MainMenu'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const OverviewMenu = () => {
  const router = useRouter()

  const userContext = useContext(UserContext)
  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  return (
    <div className="OverviewMenu">
      <div className="OverviewMenu-inner">
        <div className="OverviewMenu-wrapper">
          <div className="OverviewMenu-container">
            <ul className="OverviewMenu-list">
              <li className={`OverviewMenu-item ${linkIsActive(router.asPath, '/overview/exercises')}`}>
                <Link href="/overview/exercises">
                  <a className="OverviewMenu-link">
                    <span className="OverviewMenu-label">{t('OVERVIEWMENU__EXERCISES')}</span>
                  </a>
                </Link>
              </li>
              <li className={`OverviewMenu-item ${linkIsActive(router.asPath, '/overview/trainings')}`}>
                <Link href="/overview/trainings">
                  <a className="OverviewMenu-link">
                    <span className="OverviewMenu-label">{t('OVERVIEWMENU__TRAININGS')}</span>
                  </a>
                </Link>
              </li>
              <li className={`OverviewMenu-item ${linkIsActive(router.asPath, '/overview/programs')}`}>
                <Link href="/overview/programs">
                  <a className="OverviewMenu-link">
                    <span className="OverviewMenu-label">{t('OVERVIEWMENU__PROGRAMS')}</span>
                  </a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

OverviewMenu.propTypes = {
  name: PropTypes.string
}

export default OverviewMenu
